import React from "react";
import CustomToolTip from './ToolTip';
import clsx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";

const useStylesBootstrap = makeStyles(theme => ({
    cellTooltip: {
        padding: '5px 10px',
    },
    nameSection: {
        display: 'flex',
        alignItems: 'center'
    },
    headerContainer: {
        borderBottom: "1px solid #E6EDF5",
        display: "flex",
        flexDirection: "column",
        padding: "5px 10px"
    },
    avatar: {
        marginRight: 10,
        height: 30,
        width: 30,
        backgroundColor: "#0A54A2"
    },
    nameText: {
        display: "inline-block",
        overflow: "hidden"
    },
    nameTextBold: {
        fontSize: "16px",
        display: "inline-block",
        overflow: "hidden",
        fontWeight: "bold"
    },
    genieHeader: {
        fontSize: "12px",
        fontWeight: 700,
        color: '#878787',
        paddingRight: '5px'
    },
    genieData: {
        color: "black",
        fontSize: "12px",
    },
    tooltipBodyContainer: {
        padding: "5px 10px",
    },
}));

export default function TooltipDataviewEmployee(props) {
    const { ...classes } = useStylesBootstrap();

    let { listCol, data, employeeName = '' } = props;

    let tooltipEE =
        <React.Fragment>
            <div className={clsx(classes.cellTooltip)}>
                <div className={classes.headerContainer}>
                    <span>{employeeName}</span>
                </div>
                <table className={classes.tooltipBodyContainer}>
                    <tbody>
                        {
                            // eslint-disable-next-line array-callback-return
                            listCol.map((col) => {
                                let field = data.find(d => d.key === col.DataviewKey)
                                if (field !== undefined) {
                                    return (
                                        <tr>
                                            <td className={classes.genieHeader}>{col.Label}</td>
                                            <td className={classes.genieData}>{field.rawValue}</td>
                                        </tr>
                                    )
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        </React.Fragment>

    return (
        <CustomToolTip
            style={{ width: '100%' }}
            titleText={tooltipEE}
            jsx={
                <div className={classes.nameSection}>
                    <div className={classes.nameText}>{employeeName}</div>
                </div>
            }
        />
    );
}